<template>
  <div id="app">
    <header-component />
    <div>
      <force-password-reset-modal
        :show="passwordResetNeeded"
      />
      <router-view v-if="!passwordResetNeeded" :key="$route.fullPath" />
      <bottom-nav v-if="isMobile" />
    </div>
    <footer-component :class="isMobile ? 'pb-5' : ''" />
    <ToastContainer ref="toastContainer" />
  </div>
</template>

<script>
import BottomNav from "./components/BottomNav.vue";
import FooterComponent from "./components/FooterComponent.vue";
import ForcePasswordResetModal from "./components/ForcePasswordResetModal.vue";
import HeaderComponent from "./components/HeaderComponent.vue";
import ToastContainer from "./components/ToastContainer.vue";
import { toastService } from "./services/toast";

export default {
  name: "App",
  components: {
    HeaderComponent,
    FooterComponent,
    BottomNav,
    ToastContainer,
    ForcePasswordResetModal,
  },
  data() {
    return {
      isMobile: window.innerWidth <= 992,
    };
  },
  computed: {
    // isLoggedIn() {
    //   // Check if a token exists in local storage
    //   return !!localStorage.getItem("token");
    // },
    passwordResetNeeded() {
      return this.$store.state.passwordResetNeeded;
    },
  },
  mounted() {
    window.addEventListener("resize", this.updateSize);
    // Let the store surface error toasts (e.g. rollback / expired token).
    toastService.register(this.showToast);
    // Returning logged-in users: load canonical cart/wishlist from the server.
    if (this.$store.state.userId) {
      // TODO: remove after 2026-10-11 (one-time migration).
      // Users who were already logged in before server-side cart/wishlist
      // shipped may still have guest items in localStorage. Merge those into
      // the account instead of overwriting them. mergeGuestData is
      // self-cleaning (it clears localStorage), so this only fires once per
      // user; afterwards a logged-in user always falls through to hydrate.
      const hasLocalItems =
        this.$store.state.cart.length > 0 ||
        this.$store.state.wishlist.length > 0;
      if (hasLocalItems) {
        this.$store.dispatch("mergeGuestData");
      } else {
        this.$store.dispatch("hydrateFromServer");
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateSize);
  },
  methods: {
    updateSize() {
      this.isMobile = window.innerWidth <= 992;
    },
    // logout() {
    //   localStorage.removeItem("token");
    //   localStorage.removeItem("username");
    //   this.$router.push("/").then(() => {
    //     window.location.reload(); // Reloads the entire application
    //   });
    // },
    showToast(payload) {
      this.$refs.toastContainer.showToast(payload);
    },
  },
};
</script>

<style scoped>
#app {
  margin-top: 85px;
}
</style>
